module.exports = __webpack_public_path__ + "static/media/school.d962ec2d.svg";